import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Subject } from 'rxjs';
import { AppSettings } from '../constants/constants';

@Injectable({
  providedIn: 'root'
})
export class CartService {

  servicecartChange: Subject<boolean> = new Subject<boolean>();

  companyBO:any={}

  cartBO: any = {};
  cartColl: any = [];
  orderColl: any = [];
  cartView: any = {};

  constructor(private http: Http) { }

  fnpostInputParams(url, params) {
    const headers = new Headers({
      'sessionid': (localStorage.session === undefined) ? '' : localStorage.session,
      'token': (localStorage.adtoken === undefined) ? '' : JSON.parse(localStorage.adtoken),
      'terminal': "web",
      'authkey': "1"
    });
    return this.http.post(AppSettings.base_url + url, params, { headers: headers });
  }


  //InsertCart
  fnInsertCartProduct(params) {

    return this.fnpostInputParams(AppSettings.insertcartproductUrl, params);
  }

  //Get Cart
  fnGetCartList() {
    var data = {
      'companyid': this.companyBO.companyid,      
    }

    this.fnpostInputParams(AppSettings.getcartdetailsUrl, data)
      .subscribe(
        (res) => {
          if (res.json().status == 200) {

            let _res = res.json().result;
            
            console.log(_res)
            
            //Main
            let _cartColl = _res[0];
            if (_cartColl.length > 0) {
              this.cartBO = _cartColl[0];
            } else {
              this.cartBO = {};
            }
            //Details                          
            this.cartColl = _res[1];

            this.orderColl = _res[2];

            this.cartView = {
              "cartmain": this.cartBO,
              "cartdetails": this.cartColl,
              "orderColl":this.orderColl
            }

            this.servicecartChange.next(this.cartView);
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {
          this.fnShowErrorMsg('Error' + err);
        })


  }


  fnSetCartPlaced(params) {

    return this.fnpostInputParams(AppSettings.setcartplacedUrl, params);
  }



  fnInsertCustomerRequest(params) {

    return this.fnpostInputParams(AppSettings.insertcustomerrequestUrl, params);
  }


  private fnShowErrorMsg(ex) {
    console.log(ex);
  }


}
